import { Button } from "antd";
import { useState } from "react";
import ViewIcon from "../../../assets/icons/ViewIcon";
import { useGetSelectedEmployeesQuery } from "../../../features/attendanceSetting/attendanceSettingApi";
import { ViewSelectedUserParams } from "../../../types/attendance";
import ViewSelectedUserModal from "./ViewSelectedUserModal";

export default function SavedAttendanceUsers({ type }: { type: ViewSelectedUserParams["type"] }) {
  const [open, setOpen] = useState(false);
  // The saved count and modal share this exact database response.
  const { currentData, isFetching, isError, refetch } = useGetSelectedEmployeesQuery(
    { params: { type, skip: 0, limit: 0 } },
    { refetchOnMountOrArgChange: true }
  );
  const saved = currentData?.data;

  return (
    <div className="flex items-center gap-2">
      <span className="text-body text-sm whitespace-nowrap">
        {isError ? "Count unavailable" : isFetching ? "Loading saved…" : saved ? `${saved.total} saved` : "Count unavailable"}
      </span>
      <Button
        className="action-button"
        size="small"
        icon={<ViewIcon />}
        aria-label={`View saved ${type} employees`}
        disabled={!saved || isError || isFetching}
        onClick={() => setOpen(true)}
      />
      {isError && <Button size="small" onClick={() => refetch()}>Retry</Button>}
      {open && saved && (
        <ViewSelectedUserModal
          open={open}
          data={type}
          savedData={saved}
          handleClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}
